/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/jsx-key */

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import classnames from 'classnames';

// material
import { makeStyles } from '@mui/styles';
import { styled } from '@mui/material/styles';
import {
  Box,
  Container,
  Stack,
  AppBar,
  Toolbar,
  Typography,
  List,
  ListItem,
  ToggleButtonGroup,
  ToggleButton,
  Button,
  IconButton,
} from '@mui/material';

import { LifeBuoy } from 'lucide-react';
import { useSelector, useDispatch } from 'react-redux';

import Logo from '../../assets/logo/logo.png';
import { getCachedBranding } from '../../services/brandingService';
import AccountPopover from '../dashboard/AccountPopover';
import AnnouncementBell from '../../components/AnnouncementBell';
import SupportDrawer from '../../components/SupportDrawer';
import palette from '../../theme/palette';
import ThemeProvider from '../../theme';
import { setB2BPage } from '../../store/reducer';
import { getB2BCourseList } from '../../Redux/Action';

// ----------------------------------------------------------------------

const APPBAR_MOBILE = 52;
const APPBAR_DESKTOP = 56;
 
const RootStyle = styled(AppBar)(({ theme }) => ({
  background: 'rgb(253 253 253 / 71%)',
  backdropFilter: 'blur(6px)',
  WebkitBackdropFilter: 'blur(6px)',
  boxShadow: '0px -30px 28px -3px #686464',
  borderBottom: '2px solid #00B673',

  [theme.breakpoints.up('lg')]: {
    width: '100%',
  },
}));

const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
  minHeight: APPBAR_MOBILE,
  width: '100%',
  padding: 0,

  [theme.breakpoints.up('lg')]: {
    minHeight: APPBAR_DESKTOP,
    padding: theme.spacing(0),
  },
}));

const MainRootStyle = styled('div')({
  display: 'flex',
  minHeight: '100%',
  overflow: 'hidden',
});

const MainStyle = styled('div')(({ theme }) => ({
  width: '100%',
  minHeight: '100%',
  background: '#FAFAFA',

  [theme.breakpoints.up('lg')]: {},
}));


UserLayout.propTypes = {
  onOpenSidebar: PropTypes.func,
};


export default function UserLayout({ onOpenSidebar }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const [activeList, SetActiveList] = useState('Courses');
  const [supportDrawerOpen, setSupportDrawerOpen] = useState(false);

  const logoSrc = getCachedBranding()?.logoUrl || Logo;

  const userInfo = useSelector((state) => state.userInfo);
  const allDetails = useSelector((state) => state);

  const [satDetails, setSatDetails] = useState([]);
  const [pageName, setPageName] = useState('paid');
  const [pageNameView, setPageNameView] = useState('');
  const [alignment, setAlignment] = useState('paid');
  const [categoryList, setCategoryList] = useState([]);

  const navItem = [
    {
      name: 'Courses',
      path: '/app/course',
    },
  ];


  useEffect(() => {
    if (allDetails?.courseListB2b) {
      const categories = [
        ...new Set(
          allDetails.courseListB2b.map(
            (item) => item.category?.description
          )
        ),
      ];

      setCategoryList(categories);
    }
  }, [allDetails?.courseListB2b]);


  useEffect(() => {
    const storedToggle = localStorage.getItem('selectedToggle');

    if (storedToggle) {
      setPageName(storedToggle);
      setAlignment(storedToggle);
    }
  }, []);


  useEffect(() => {
    if (alignment) {
      localStorage.setItem('selectedToggle', alignment);
    }
  }, [alignment]);

  const handlePaidClick = () => {
    setAlignment('paid');
    setPageName('paid');

    localStorage.setItem('selectedToggle', 'paid');

    dispatch(setB2BPage('paid'));
  };

  const handleFreeClick = () => {
    setAlignment('free');
    setPageName('free');

    localStorage.setItem('selectedToggle', 'free');

    dispatch(setB2BPage('free'));
  };
  // const handleChange = (event, newAlignment) => {
  //   if (newAlignment !== null) {
  //     setAlignment(newAlignment);
  //     setPageName(newAlignment);

  //     localStorage.setItem('selectedToggle', newAlignment);

  //     dispatch(setB2BPage(newAlignment));
  //   }
  // };

  const handleSatNavigate = () => {
    setAlignment('sat');
    setPageName('sat');

    localStorage.setItem('selectedToggle', 'sat');

    navigate('/app/sat');
  };


  const CallBack = (data) => {
    setPageNameView(data);
  };


  useEffect(() => {
    const storedToggle = localStorage.getItem('selectedToggle');

    const searchParams = new URLSearchParams(location.search);
    const isFree = searchParams.get('free') === 'true';

    if (location.pathname.includes('/app/sat')) {
      setAlignment('sat');
      setPageName('sat');

      localStorage.setItem('selectedToggle', 'sat');
    } else if (location.pathname.includes('/app/course')) {
      if (isFree) {
        setAlignment('free');
        setPageName('free');

        localStorage.setItem('selectedToggle', 'free');
      } else if (storedToggle) {
        setAlignment(storedToggle);
        setPageName(storedToggle);
      } else {
        setAlignment('paid');
        setPageName('paid');

        localStorage.setItem('selectedToggle', 'paid');
      }
    } else if (storedToggle) {
      setAlignment(storedToggle);
      setPageName(storedToggle);
    }
  }, [location.pathname, location.search]);


  const PathDisable = location?.pathname.includes(
    '/app/NeetSimulation'
  );


  return (
    <>
      <ThemeProvider>
        <MainRootStyle>
          <RootStyle position="fixed">
            <ToolbarStyle>
              <Container
                className={classes.container}
                sx={{
                  width: '100%',
                  '@media (min-width: 1536px)': {
                    maxWidth: '100% !important',
                  },
                }}
              >
                <div className={classes.headerContainer}>

                  <div className={classes.logoContainer}>
                    <Box
                      onClick={() => {
                        if (!PathDisable) {
                          navigate('/app/course');

                          dispatch(
                            getB2BCourseList(
                              userInfo?.id,
                              'paid'
                            )
                          );
                        }
                      }}
                      sx={{
                        display: 'flex',
                        alignItems: 'center',

                        ...(allDetails?.FromGeneralAssessment === true &&
                          (
                            location.pathname.includes(
                              '/app/assessment'
                            ) ||
                            location.pathname.includes(
                              '/app/NeetSimulation'
                            ) ||
                            location.pathname.includes(
                              '/app/SATAssessment'
                            ) ||
                            location.pathname.includes(
                              '/app/SATExamSimulation'
                            )
                          )
                          ? {
                            cursor: 'unset',
                            pointerEvents: 'none',
                          }
                          : {
                            cursor: 'pointer',
                          }),
                      }}
                    >
                      <img
                        src={logoSrc}
                        alt="logo"
                        className={classes.logo}
                      />
                    </Box>
                  </div>



                  <div className={classes.toggleContainer}>
                    {!(
                      allDetails?.FromGeneralAssessment === true &&
                      location.pathname.includes('/app/assessment')
                    ) &&
                      location.pathname === '/app/course' && (
                        <ToggleButtonGroup
                          color="primary"
                          value={alignment}
                          exclusive
                          aria-label="Platform"
                          sx={{
                            borderRadius: '40px',
                            boxShadow: 'rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px',
                            padding: '4px',
                            marginRight: { lg: '10px', md: '5px', sm: '0px', xs: '0px' },
                            '& .MuiToggleButton-root': {
                              border: 'none',
                              padding: { xs: '6px 10px', sm: '8px 16px' },
                              color: '#bdbdbd',
                              whiteSpace: 'nowrap',
                              fontSize: { xs: '0.8rem', sm: '0.9rem' },
                              '&.Mui-selected': {
                                color: '#FE7000',
                                backgroundColor: 'rgb(247 163 47 / 15%)',
                                borderRadius: '40px',
                                '&:hover': {
                                  backgroundColor: 'rgb(255 193 107 / 15%)',
                                  borderRadius: '40px',
                                }
                              },
                              '&:hover': {
                                backgroundColor: 'rgb(255 193 107 / 15%)',
                                borderRadius: '40px',
                              }
                            }
                          }}
                        >
                          <ToggleButton
                            value="paid"
                            onClick={handlePaidClick}
                          >
                            Allotted
                          </ToggleButton>

                          <ToggleButton
                            value="free"
                            onClick={handleFreeClick}
                            style={{
                              border: 'none',
                            }}
                          >
                            Free
                          </ToggleButton>
                          {/* <ToggleButton 
                          value="paid"
                          onChange={handleChange}
                        >
                          Allotted
                        </ToggleButton>
                        <ToggleButton
                       
                          value="free"
                          disabled={!allDetails?.courseListB2b?.some(
                            course => course.is_free === true || course.is_free === "true"
                          )}
                          onChange={handleChange} 
                          style={{
                              border: 'none',
                              }}>
                          Free
                          {/* {console.log( allDetails?.courseListB2b.length , allDetails?.courseListB2b?.filter(course => course.is_free)?.length, "courseFree1111")} */}
                        {/* </ToggleButton> */}
                    {satDetails && satDetails.length !== 0 && (
                      <ToggleButton
                        value="sat"
                        onClick={handleSatNavigate}
                      >
                        SAT
                      </ToggleButton>
                    )}
                  </ToggleButtonGroup>
                      )}
                </div>


                <div className={classes.userContainer}>

                  {allDetails?.FromGeneralAssessment === true &&
                    location.pathname.includes('/app/assessment') ? null : (
                    <List className={classes.userList}>
                      {userInfo?.role === 'AUTH_USER' &&
                        !location.pathname.includes(
                          '/app/NeetSimulation'
                        ) &&
                        navItem.map((res) => (
                          <ListItem
                            key={res.name}
                            disableRipple
                            onClick={() => {
                              navigate(res.path);
                              SetActiveList(res.name);
                            }}
                            className={classnames(
                              classes.linkText,
                              {
                                [classes.linkTextActive]:
                                  activeList === res.name,
                              }
                            )}
                          >
                            <Typography
                              id="userInfoName"
                              className={classes.userName}
                            >
                              {userInfo?.name}
                            </Typography>
                          </ListItem>
                        ))}
                    </List>
                  )}

                  {userInfo?.role === 'CONTENT_WRITER' && (
                    <Typography
                      variant="subtitle1"
                      className={classes.contentWriterName}
                    >
                      {userInfo?.name}
                    </Typography>
                  )}



                  {!(
                    allDetails?.FromGeneralAssessment === true &&
                    (
                      location.pathname.includes(
                        '/app/assessment'
                      ) ||
                      location.pathname.includes(
                        '/app/NeetSimulation'
                      )
                    )
                  ) && (
                      <Stack
                        direction="row"
                        alignItems="center"
                        justifyContent="flex-end"
                        spacing={0}
                        className={classes.actionContainer}
                      >



                        <IconButton
                          onClick={() =>
                            setSupportDrawerOpen(true)
                          }
                          title="Get Help & Feedback"
                          size="small"
                          className={classes.mobileHelpButton}
                        >
                          <LifeBuoy
                            size={18}
                            strokeWidth={2}
                          />
                        </IconButton>

                        <Button
                          onClick={() =>
                            setSupportDrawerOpen(true)
                          }
                          startIcon={
                            <LifeBuoy
                              size={18}
                              strokeWidth={2}
                            />
                          }
                          className={classes.desktopHelpButton}
                        >
                          Get Help &amp; Feedback
                        </Button>



                        <Box
                          className={classes.announcementContainer}
                        >
                          <AnnouncementBell />
                        </Box>

                        <Box
                          className={classes.accountContainer}
                        >
                          <AccountPopover
                            coming="B2B"
                            CallBack={CallBack}
                          />
                        </Box>

                      </Stack>
                    )}
                </div>
              </div>
            </Container>
          </ToolbarStyle>
        </RootStyle>

        <MainStyle>
          <Outlet />
        </MainStyle>


        <SupportDrawer
          open={supportDrawerOpen}
          onClose={() => setSupportDrawerOpen(false)}
          viewAllPath="/app/support"
        />
      </MainRootStyle>
    </ThemeProvider >
    </>
  );
}


const useStyles = makeStyles(() => ({


  headerContainer: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    minWidth: 0,
    height: '100%',
  },

  container: {
    width: '100%',
    maxWidth: '1536px',

    '@media (min-width: 1536px)': {
      maxWidth: '100% !important',
    },

    '@media (min-width: 1201px)': {
      padding: '0px 2rem',
    },

    '@media (min-width: 601px) and (max-width: 1200px)': {
      padding: '0px 1rem',
    },

    '@media (max-width: 600px)': {
      padding: '0px 6px',
    },
  },

  logoContainer: {
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0,

    '@media (max-width: 600px)': {
      marginRight: '4px',
    },
  },

  logo: {
    maxHeight: '48px',
    width: 'auto',
    maxWidth: '110px',
    display: 'block',

    '@media (max-width: 600px)': {
      maxHeight: '38px',
      maxWidth: '75px',
    },

    '@media (max-width: 360px)': {
      maxHeight: '34px',
      maxWidth: '68px',
    },
  },

  // --------------------------------------------------------------------
  // Toggle
  // --------------------------------------------------------------------

  toggleContainer: {
    display: 'flex',
    flex: 1,
    minWidth: 0,
    alignItems: 'center',
    justifyContent: 'flex-end',

    '@media (max-width: 768px)': {
      marginLeft: 'auto',
      marginRight: '2px',
      overflow: 'hidden',
    },

    '@media (max-width: 600px)': {
      flex: '0 1 auto',
      maxWidth: 'calc(100% - 190px)',
    },

    '@media (max-width: 360px)': {
      maxWidth: 'calc(100% - 155px)',
    },
  },

  // --------------------------------------------------------------------
  // User container
  // --------------------------------------------------------------------

  userContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',

    flexShrink: 0,
    minWidth: 0,

    '@media (max-width: 600px)': {
      marginLeft: '2px',
      gap: '0px',
    },
  },

  // --------------------------------------------------------------------
  // User list
  // --------------------------------------------------------------------

  userList: {
    display: 'flex',
    padding: 0,
    margin: 0,
    flexShrink: 1,

    '@media (max-width: 600px)': {
      display: 'none',
    },
  },

  userName: {
    color: '#969da3',
    fontSize: '14px !important',
    fontWeight: '400',
    letterSpacing: '0.4px',
    maxWidth: '65px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    marginRight: '10px',

    '@media (max-width: 600px)': {
      display: 'none',
    },
  },

  contentWriterName: {
    fontSize: '1rem',
    fontWeight: '400',
    letterSpacing: '0.4px',
    color: '#969da3 !important',
    marginRight: '10px',
    whiteSpace: 'nowrap',

    '@media (max-width: 600px)': {
      display: 'none',
    },
  },

  // --------------------------------------------------------------------
  // Action container
  // --------------------------------------------------------------------

  actionContainer: {
    flexShrink: 0,
    minWidth: 0,
    width: 'auto',
    height: '40px',
    margin: 0,

    '& > *': {
      flexShrink: 0,
    },

    '@media (max-width: 600px)': {
      gap: '0px',
      height: '40px',
    },
  },

  // --------------------------------------------------------------------
  // Mobile help
  // --------------------------------------------------------------------

  mobileHelpButton: {
    display: 'none !important',

    '@media (max-width: 600px)': {
      display: 'inline-flex !important',
      width: '32px',
      height: '32px',
      padding: 0,
      color: '#687684',
      flexShrink: 0,
      margin: 0,
    },
  },

  // --------------------------------------------------------------------
  // Desktop help
  // --------------------------------------------------------------------

  desktopHelpButton: {
    display: 'inline-flex !important',
    textTransform: 'none',
    fontWeight: 600,
    fontSize: '0.8rem',
    color: '#687684',
    whiteSpace: 'nowrap',
    paddingLeft: '12px',
    paddingRight: '12px',
    minWidth: 'auto',
    flexShrink: 0,

    '@media (max-width: 600px)': {
      display: 'none !important',
    },
  },

  // --------------------------------------------------------------------
  // Announcement Bell
  // --------------------------------------------------------------------

  announcementContainer: {
    width: '40px',
    minWidth: '40px',
    height: '40px',

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    flexShrink: 0,
    position: 'relative',

    overflow: 'visible',

    '@media (max-width: 600px)': {
      width: '34px',
      minWidth: '34px',
      height: '40px',
      marginLeft: '1px',
      marginRight: '1px',
    },

    '@media (max-width: 360px)': {
      width: '32px',
      minWidth: '32px',
    },
  },


  accountContainer: {
    marginLeft: '15px!important',
    width: '44px',
    minWidth: '44px',
    height: '40px',

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    flexShrink: 0,
    position: 'relative',

    overflow: 'visible',

    '@media (max-width: 600px)': {
      width: '40px',
      minWidth: '40px',
      height: '40px',
      marginLeft: '2px',
    },

    '@media (max-width: 360px)': {
      width: '38px',
      minWidth: '38px',
    },
  },



  linkText: {
    color: '#000',

    '&:hover': {
      backgroundColor: 'transparent',
    },
  },

  linkTextActive: {
    color: palette.primary.main,
    fontSize: '1.2rem',
  },
}));

